import {
  removeLeadingZeros,
  removeWhiteSpaces
} from './../../utils/strings'

export const CURRENCIES = ['COP', 'MXN', 'USD', 'EUR', 'BTC']

export const CURRENCY_SYMBOLS = ['$', '€', '£', 'R$', '₿']

export const KEPT_BEHAVIOUR_KEYS = [
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Meta',
  'Shift'
]

export const cleanOutput = (str) => {
  let cleanString = str.replace(/\D/g, '')

  cleanString = removeWhiteSpaces(cleanString)

  if(cleanString[0] === '0' && cleanString.length > 1) {
    cleanString = removeLeadingZeros(cleanString)
  }

  return cleanString
}
